import {useAction, useResource, useResourceList} from '../useBaseHooks';
import {useCallback, useEffect, useState}        from 'react';
import {
	getUserBillingCreateEndpoint,
	getUserBillingEndpoint,
	getUserBillingsEndpoint
}                                                from '../endpoints/user/userBillingEndpoints';
import {useUserLocationUpdate}                   from './useUserLocation';
import {useUserBillingMethods}                   from './useUserBillingMethod';

export const useUserBillings = (userId, restSettings = null) => useResourceList(getUserBillingsEndpoint(userId), restSettings);
export const useUserBillingUpdate = billingId => useAction(getUserBillingEndpoint(billingId), 'PATCH');
export const useUserBilling = (billingId, params = null, restSettings = null) => useResource(getUserBillingEndpoint(billingId), params, restSettings);
export const useUserBillingUpdateLocation = (billingId, locationId) => {
	const [_updateBilling, updatingBilling] = useAction(getUserBillingEndpoint(billingId), 'PATCH');
	const [_updateLocation, updatingLocation] = useUserLocationUpdate(locationId);

	const doAction = useCallback((data, settingsOverride = {}) => {
		return _updateLocation(data, {
			snackMessageToken: null,
			innerThen: location => {
				return _updateBilling({ User_Location__: location.User_Location__ }, {
					snackMessageToken: 'user_location_update_success',
					...settingsOverride,
				});
			}
		});
	}, []); //eslint-disable-line

	return [doAction, updatingBilling || updatingLocation];
};

export const useUserBillingCreateWithMethod = () => {
	const [_doAction, loading] = useAction(getUserBillingCreateEndpoint(), 'POST', { snackMessageToken: 'user_billing_created' });

	const doAction = useCallback((label, userLocationId, method, methodData = {}, settingsOverride = {}) => _doAction({
		Label: label,
		User_Location__: userLocationId,
		method: method,
		...methodData
	}, settingsOverride), []); //eslint-disable-line

	return [doAction, loading];
};


export const useFirstUserBilling = userId => {
	const [, fetch] = useUserBillings(userId);
	const [billing, setBilling] = useState(null);

	const refresh = useCallback(
		data => {
			if (data) {
				setBilling({ ...(billing ?? {}), data: data });
				return;
			}

			fetch()
				.then(d => (d.data && d.data.length > 0) ? setBilling({ data: d.data[0] }) : setBilling({ data: null }))
				.catch(e => {
					setBilling({ error: e });
				});
		}
		, [billing]); //eslint-disable-line

	useEffect(() => {
		refresh();
	}, []); //eslint-disable-line


	return [billing, refresh];
};

export const useFirstPaymentMethod = billingId => {
	const [, fetch] = useUserBillingMethods(billingId);
	const [method, setMethod] = useState(null);

	const refresh = useCallback(
		data => {
			if (data) {
				setMethod({ ...(method ?? {}), data: data });
				return;
			}

			fetch()
				.then(d => (d.data && d.data.length > 0) ? setMethod({ data: d.data[0] }) : setMethod({ data: null }))
				.catch(e => {
					setMethod({ error: e });
				});
		}
		, [method]); //eslint-disable-line

	useEffect(() => {
		refresh();
	}, []); //eslint-disable-line


	return [method, refresh];
};